import { render } from "./UnitTable.vue?vue&type=template&id=0ec7f0ca"
import script from "./UnitTable.vue?vue&type=script&lang=ts"
export * from "./UnitTable.vue?vue&type=script&lang=ts"
script.render = render

export default script